import request from '@/utils/request'

export function getAllData(params) {
  return request({
    url: 'getZlData',
    method: 'get',
    params: params,
  })
}
export function getZtkData(params) {
  return request({
    url: 'getZtkData',
    method: 'get',
    params: params,
  })
}
// /bigScreen/allCount  总览
export function allCount(params) {
  return request({
    url: '/bigScreen/allCount',
    method: 'get',
    params: params,
    // headers: {
    //   Authorization: 'bearer 8b2999e0-8ca7-48ba-9dcc-aeee9f6f85ce',
    //   token: 'bearer 8b2999e0-8ca7-48ba-9dcc-aeee9f6f85ce',
    // },
  })
}

//一级运动员  /bigScreen/oneBigScreen
export function oneBigScreen(params) {
  return request({
    url: '/bigScreen/oneBigScreen',
    method: 'get',
    params: params,
  })
}

//二三级运动员  /bigScreen/twoThreeBigScreen
export function twoThreeBigScreen(params) {
  return request({
    url: '/bigScreen/twoThreeBigScreen',
    method: 'get',
    params: params,
  })
}

//教练员 - 市级体育系统教练员  /bigScreen/jlyStyjBigScreen
export function jlyStyjBigScreen(params) {
  return request({
    url: '/bigScreen/jlyStyjBigScreen',
    method: 'get',
    params: params,
  })
}

//教练员 - 区级体育系统教练员  /bigScreen/jlyQtyjBigScreen
export function jlyQtyjBigScreen(params) {
  return request({
    url: '/bigScreen/jlyQtyjBigScreen',
    method: 'get',
    params: params,
  })
}

//教练员 - 非体育系统编制  -  联办优秀运动队教练员 /bigScreen/fTyxLbBigScreen
export function fTyxLbBigScreen(params) {
  return request({
    url: '/bigScreen/fTyxLbBigScreen',
    method: 'get',
    params: params,
  })
}

//教练员 - 社会力量办训   /bigScreen/shllBigScreen
export function shllBigScreen(params) {
  return request({
    url: '/bigScreen/shllBigScreen',
    method: 'get',
    params: params,
  })
}

//教练员 - 教育系统 /bigScreen/jyxtBigScreen
export function jyxtBigScreen(params) {
  return request({
    url: '/bigScreen/jyxtBigScreen',
    method: 'get',
    params: params,
  })
}

//裁判员 - 裁判员  /bigScreen/cpyBigScreen
export function cpyBigScreen(params) {
  return request({
    url: '/bigScreen/cpyBigScreen',
    method: 'get',
    params: params,
  })
}

//其他专业人员 - 社会体育指导员  /bigScreen/qtShtyBigScreen
export function qtShtyBigScreen(params) {
  return request({
    url: '/bigScreen/qtShtyBigScreen',
    method: 'get',
    params: params,
  })
}

//科医人员  /bigScreen/kyKyryBigScreen
export function kyKyryBigScreen(params) {
  return request({
    url: '/bigScreen/kyKyryBigScreen',
    method: 'get',
    params: params,
    // headers: {
    //   Authorization: 'bearer 8b2999e0-8ca7-48ba-9dcc-aeee9f6f85ce',
    //   token: 'bearer 8b2999e0-8ca7-48ba-9dcc-aeee9f6f85ce',
    // },
  })
}
//医务人员  /bigScreen/kyDoctorBigScreen
export function kyDoctorBigScreen(params) {
  return request({
    url: '/bigScreen/kyDoctorBigScreen',
    method: 'get',
    params: params,
    // headers: {
    //   Authorization: 'bearer 8b2999e0-8ca7-48ba-9dcc-aeee9f6f85ce',
    //   token: 'bearer 8b2999e0-8ca7-48ba-9dcc-aeee9f6f85ce',
    // },
  })
}
// 运动防护师  /bigScreen/kyYdfhsBigScreen
export function kyYdfhsBigScreen(params) {
  return request({
    url: '/bigScreen/kyYdfhsBigScreen',
    method: 'get',
    params: params,
    // headers: {
    //   Authorization: 'bearer 8b2999e0-8ca7-48ba-9dcc-aeee9f6f85ce',
    //   token: 'bearer 8b2999e0-8ca7-48ba-9dcc-aeee9f6f85ce',
    // },
  })
}
// 管理岗位  /bigScreen/managerBigScreen
export function managerBigScreen(params) {
  return request({
    url: '/bigScreen/managerBigScreen',
    method: 'get',
    params: params,
    // headers: {
    //   Authorization: 'bearer 8b2999e0-8ca7-48ba-9dcc-aeee9f6f85ce',
    //   token: 'bearer 8b2999e0-8ca7-48ba-9dcc-aeee9f6f85ce',
    // },
  })
}
//专技岗位  /bigScreen/majorBigScreen
export function majorBigScreen(params) {
  return request({
    url: '/bigScreen/majorBigScreen',
    method: 'get',
    params: params,
    // headers: {
    //   Authorization: 'bearer 8b2999e0-8ca7-48ba-9dcc-aeee9f6f85ce',
    //   token: 'bearer 8b2999e0-8ca7-48ba-9dcc-aeee9f6f85ce',
    // },
  })
}

//专技人员  /bigScreen/zyjnBigScreen
export function zyjnBigScreen(params) {
  return request({
    url: '/bigScreen/zyjnBigScreen',
    method: 'get',
    params: params,
  })
}

//职业技能人员年份数据  /bigScreen/zyjnBigScreen
export function zyjnYearBigScreen() {
  return request({
    url: '/bigScreen/zyjnYearBigScreen',
    method: 'get',
  })
}